// extracted by mini-css-extract-plugin
export default {"banner":"verificationBanner_banner__QPvU3","bannerText":"verificationBanner_bannerText__Uv5RG","button":"verificationBanner_button__Vttpd"};